






















import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IInvoiceParty } from "@/models/invoice-party.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters: {}
})
export default class InvoicePartySheet extends mixins(PermissionMixin) {
  @Prop()
  invoiceParty!: IInvoiceParty;

  @Prop({ default: "grey lighten-4" })
  color!: string;
}
